import type { IssueDefinition } from "../../issue-definition";
import { ISSUE_CATEGORY } from "../../issue-enums";
import { ISSUE_OPERATOR_ACTION } from "../../issue-operator-action";

/**
 * An Aurora backup or copy JOB failed — the early warning for both Aurora
 * staleness codes.
 *
 * ONE CODE FOR BOTH JOB KINDS, matching its Forgejo twin and for the same
 * reason: a failed job of either kind asks the same next question — read the
 * job's status message — so splitting it would produce two alarms with one
 * investigation. The payload names which kind it was.
 *
 * It fires the day something breaks, where a staleness alarm cannot appear until
 * the last good point ages past the RPO threshold.
 */
export const VIBE_TENANT_AURORA_BACKUP_JOB_FAILING = {
  category: ISSUE_CATEGORY.OBSERVABILITY,
  message:
    "The most recent AWS Backup job for this tenant's Aurora cluster failed — either the backup into its own-region vault or the cross-region copy out of it; the issue payload says which, and carries AWS's own status message. Separate from the two Aurora staleness alarms on purpose: this fires the day the job breaks, while a stale recovery point only becomes visible once the last good one ages past the RPO threshold, which throws away a full cycle of warning. Separate from the Forgejo volume's job alarm because the two run under different plans against different resources, and one failing says nothing about the other. Cleared once a job of that kind succeeds.",
  severity: "high",
  remedy:
    "Run the backup now to retry. Read the payload's status message first — an IAM fault, a vault-lock rule or a KMS grant that no longer resolves will fail the same way again immediately, and needs fixing in AWS before retrying helps. A snapshot refused because one is already in progress is the benign case and clears on its own.",
  operatorAction: ISSUE_OPERATOR_ACTION.VIBE_RUN_TENANT_BACKUP_NOW
} as const satisfies IssueDefinition;
